"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionItemResponseTestPackageTypeEnum = exports.RequisitionItemResponseStatusEnum = exports.RequisitionItemResponseSpecialTypesEnum = exports.RequisitionItemResponseSourceEnum = exports.RequisitionItemResponseReqtypeEnum = exports.RequisitionItemResponseParentTypeEnum = exports.RequisitionItemResponseOrderTypeEnum = exports.RequisitionItemResponseOrderTagsEnum = exports.RequisitionItemResponsePaymentStatusEnum = exports.RequisitionItemResponseFormattedStageEnum = void 0;
exports.RequisitionItemResponseFormattedStageEnum = {
    KitPurchased: 'KIT PURCHASED',
    KitShipped: 'KIT SHIPPED',
    OrderApproved: 'ORDER APPROVED',
    OrderSubmitted: 'ORDER SUBMITTED',
    SpecimenReceived: 'SPECIMEN RECEIVED',
    LabProcessing: 'LAB PROCESSING',
    PreCropHold: 'PRE-CROP HOLD',
    AnalysisAndInterpretation: 'ANALYSIS AND INTERPRETATION',
    PostCropHold: 'POST-CROP HOLD',
    ReportReleased: 'REPORT RELEASED',
    Cancelled: 'CANCELLED'
};
exports.RequisitionItemResponsePaymentStatusEnum = {
    Complete: 'complete',
    Pending: 'pending',
    Empty: ''
};
exports.RequisitionItemResponseOrderTagsEnum = {
    ConsentSigned: 'consent signed',
    ExomeSlice: 'exome_slice',
    FormsSubmitted: 'forms submitted',
    GeneticCounselingDismissed: 'genetic counseling dismissed',
    HealthHistoryCompleted: 'health history completed',
    KitActivated: 'kit activated',
    KitPurchased: 'kit purchased',
    KitShipped: 'kit shipped',
    LowOopEstimateEmailSent: 'low oop estimate email sent',
    LowOopEstimateSmsSent: 'low oop estimate sms sent',
    OopEmailSent: 'oop email sent',
    OopSmsSent: 'oop sms sent',
    OrderApproved: 'order approved',
    PatientDetailsCompleted: 'patient details completed',
    PatientPayEmailSent: 'patient pay email sent',
    PatientPaySmsSent: 'patient pay sms sent',
    PwnResultOnHold: 'pwn result on hold'
};
exports.RequisitionItemResponseOrderTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
exports.RequisitionItemResponseParentTypeEnum = {
    DemoteToDuoRemoveFather: 'demote_to_duo_remove_father',
    DemoteToDuoRemoveMother: 'demote_to_duo_remove_mother',
    DemoteToProbandOnly: 'demote_to_proband_only',
    PreventiveReport: 'preventive_report',
    Rereq: 'rereq',
    Rerun: 'rerun',
    Switch: 'switch',
    Upgrade: 'upgrade',
    Empty: ''
};
exports.RequisitionItemResponseReqtypeEnum = {
    AnonymousBlood: 'Anonymous Blood',
    Clinical: 'Clinical',
    ClinicalCollaboration: 'Clinical Collaboration',
    Internal: 'Internal',
    PositiveControl: 'Positive Control',
    Research: 'Research'
};
exports.RequisitionItemResponseSourceEnum = {
    Api: 'api',
    Backoffice: 'backoffice',
    Cgc: 'cgc',
    ClinicHub: 'clinic_hub',
    Emr: 'emr',
    Fht: 'fht',
    PatientInitiated: 'patient_initiated',
    PatientShare: 'patient_share',
    Portal: 'portal',
    PortalBouncer: 'portal-bouncer',
    Unspecified: 'unspecified'
};
exports.RequisitionItemResponseSpecialTypesEnum = {
    FetalSample: 'fetal_sample',
    FvtExternal: 'fvt_external',
    FvtExternalWithPositiveControl: 'fvt_external_with_positive_control',
    FvtInternal: 'fvt_internal',
    FvtOnly: 'fvt_only',
    FvtWithAdditionalGenes: 'fvt_with_additional_genes',
    FvtWithFullGene: 'fvt_with_full_gene',
    HematologicMalignancy: 'hematologic_malignancy',
    Other: 'other',
    PositiveControl: 'positive_control',
    Reflex: 'reflex',
    TestOfRelatedSamples: 'test_of_related_samples',
    TestOfRelatedSamplesNeedsJointAnalysis: 'test_of_related_samples_needs_joint_analysis',
    Tp53VariantProgram: 'tp53_variant_program',
    VusRecommended: 'vus_recommended',
    VusResolution: 'vus_resolution'
};
exports.RequisitionItemResponseStatusEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    PreCropHold: 'PRE_CROP_HOLD',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    PostCropHold: 'POST_CROP_HOLD',
    ReportReleased: 'REPORT_RELEASED',
    Cancelled: 'CANCELLED'
};
exports.RequisitionItemResponseTestPackageTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
